<template>
  <div class="urlcheck urlcheck fixed bottom">
    <div>
      <div class="pointer">
        <div class="left">
          <img src="/assets/hand.png" />
        </div>
        <div class="right max">
          <img src="/assets/hand.png" />
        </div>
      </div>
      <div class="watermark">
        <div class="holder">
          <div class="left th"></div>
          <div class="mid">
            <div></div>
          </div>
        </div>
      </div>
      <div class="checktext">
        <div class>{{ $t("url_checker") }}</div>
      </div>
    </div>
  </div>
</template>
